import _loadable from '@loadable/component';
import {Loading} from './Loading.react';
/**
 * @typedef {Object} LoadableOptions
 * @property {React.Component} [loading=Loading] The component to display while the import is resolving.
 * @property {number} [timeout=10000] The amount of time we'll wait for this component before rendering
 */
/**
 * @type LoadableOptions
 */
const defaultOptions = {
  loading: Loading,
  timeout: 10000
};
/**
 * A simple wrapper for the `@loadable/component` library for sharing a default configuration and behavior.
 *
 * This *must* export a `loadable` function to ensure compatibility with the `@loadable/babel-plugin`.
 *
 * @param {LoadableComponent} loadableComponent {@link https://www.smooth-code.com/open-source/loadable-components/docs/api-loadable-component/#loadablecomponent-1}
 * @param {LoadableOptions} options
 * @example `loadable(() => import('./Component.react'))`
 * @see https://www.smooth-code.com/open-source/loadable-components/docs/babel-plugin/#loadable-detection
 */
export function loadable(loadableComponent, options) {
  options = {
    ...defaultOptions,
    ...options
  };
  /**
   * Map our `loadable` options to the proper `@loadable/component` options.
   */
  const loadableOptions = {
    fallback: options.loading
  };
  return _loadable(loadableComponent, loadableOptions);
}
